module.exports = __webpack_public_path__ + "img/warn.9b03f44c.svg";